/**
 * Configuração central do produto — nome, slogan, contato, constantes visuais.
 * É a única fonte da verdade: nada de nome de marca escrito à mão em componente.
 *
 * Nome definido em 08/08/2026 (ver documentacao/03-branding-nomes.md).
 * O domínio `iabordo.com.br` está registrado.
 */
export const PRODUCT = {
  name: 'IA Bordo',
  tagline: 'O diário de bordo que trabalha por você.',
  shortDescription: 'O diário de bordo moderno da sua frota.',
  supportEmail: 'suporte@iabordo.com.br',
  website: 'https://iabordo.com.br',
  termsVersion: '1.0',

  /**
   * App do motorista, distribuído por nós como APK.
   *
   * Não está nas lojas: a Play Store leva semanas entre conta, revisão e
   * política de testadores, e os motoristas precisam do app antes disso. O
   * arquivo é publicado pela CI em cada versão da `main` e servido pelo Caddy
   * fora do container do site — assim publicar o app não depende de fazer
   * deploy do painel, nem o contrário.
   *
   * O `versao.json` ao lado é o que diz se já existe algo publicado. A tela
   * consulta antes de oferecer o download: link para arquivo inexistente é
   * pior do que dizer que ainda não há app.
   */
  appAndroidUrl: 'https://iabordo.com.br/baixar/iabordo-motorista.apk',
  appVersaoUrl: 'https://iabordo.com.br/baixar/versao.json',
} as const;

/**
 * Preço por veículo ativo, por mês, em centavos.
 *
 * É só um FALLBACK para a landing renderizar se a API estiver fora. A fonte da
 * verdade é `tenants.price_per_vehicle_cents` no banco, exposta pelo
 * `GET /billing/plans` — assim vitrine e fatura não divergem.
 */
export const PRECO_POR_VEICULO_CENTS = 3900;
